/**
* Retrieves the EinsteinUtils object from the window
* @returns {object} - the EinsteinUtils object or null if not found
*/
function getEinsteinUtils() {
    const einsteinUtils = window.CQuotient;

    if (einsteinUtils && (typeof einsteinUtils.getCQUserId === "function") && (typeof einsteinUtils.getCQCookieId === "function")) {
        return einsteinUtils;
    }

    return null;
}

/**
* Creates a product anchor based on the given layout container
* @param {object} $layoutContainer - jQuery object of the layout container
* @returns {object} - an array of objects containing product id, sku, type and alt_id
*/
function createProductAnchor($layoutContainer) {
    return [{
        id: $layoutContainer.attr("data-einstein-primary-product-id"),
        sku: $layoutContainer.attr("data-einstein-secondary-product-id"),
        type: $layoutContainer.attr("data-einstein-alternative-group-type"),
        alt_id: $layoutContainer.attr("data-einstein-alternative-group-id")
    }];
}

/**
* Fills the DOM element with the recommended products
* @param {object} einsteinResponse - response from the Einstein API
* @param {object} $layoutContainer - the jQuery object of the layout container
* @param {string} einsteinRecommender - the name of the Einstein recommender
* @param {function} initCarousel - the carousel initialization function
*/
function fillDomElement(einsteinResponse, $layoutContainer, einsteinRecommender, initCarousel) {
    const recommendedProducts = einsteinResponse[einsteinRecommender].recs;

    if (recommendedProducts && recommendedProducts.length > 0) {
        const template = $layoutContainer.attr("data-einstein-tile-template");
        const loadUrl = $layoutContainer.attr("data-einstein-product-load-url");
        const url = new URL(loadUrl);
        let components = [];

        components = recommendedProducts.map(function (recommendedProduct) {
            return {
                template: template,
                model: {
                    type: "product",
                    id: recommendedProduct.id
                }
            };
        });

        url.searchParams.append("components", JSON.stringify(components));

        $.ajax({
            url: url.href,
            type: "get",
            dataType: "html",
            success: function (html) {
                const $contentTilesCarousel = $layoutContainer.find(".js-content-tiles-carousel");
                $contentTilesCarousel.addClass(`sliders-count-${components.length}`);
                $contentTilesCarousel.html(html);
                $contentTilesCarousel.find(".product-tile").wrap("<div class='slide-wrapper'></div>");
                initCarousel($contentTilesCarousel);
            }
        });
    }
}

/**
* Loads recommendations from Einstein
* @param {object} $layoutContainer - DOM element to be filled with recommendations
* @param {string} einsteinRecommender - name of the recommender
* @param {function} initCarousel - the carousel initialization function
*/
export function loadRecommendations($layoutContainer, einsteinRecommender, initCarousel) {
    const einsteinUtils = getEinsteinUtils();

    if (einsteinUtils) {
        const params = {
            userId: einsteinUtils.getCQUserId(),
            cookieId: einsteinUtils.getCQCookieId(),
            ccver: "1.01",
            anchors: createProductAnchor($layoutContainer)
        };

        const recommendationsReceived = (einsteinResponse) => {
            fillDomElement(einsteinResponse, $layoutContainer, einsteinRecommender, initCarousel);
        };

        if (einsteinUtils.getRecs) {
            einsteinUtils.getRecs(einsteinUtils.clientId, einsteinRecommender, params, recommendationsReceived);
        } else {
            einsteinUtils.widgets = einsteinUtils.widgets || [];
            einsteinUtils.widgets.push({
                recommenderName: einsteinRecommender,
                parameters: params,
                callback: recommendationsReceived
            });
        }
    }
}
